class Dropdown
{
	private m_Element: JQuery;

	constructor()
	{
		this.m_Element = $( ui.ul() );

		this.m_Element.addClass( 'dropdown-menu' );
	}

	public addItem(): JQuery
	{
		const li = $( ui.li() );

		this.m_Element.append( li );

		return li;
	}

	public getElement(): JQuery
	{
		return this.m_Element;
	}
}
